import React, { FC, useMemo } from 'react';
import {
  useEngineInstance,
  useSubjectId
} from '@surveycake/react-logic-engine';
import { useStyles } from './styles';

const ContentContainer: FC = ({ children }) => {
  const engine = useEngineInstance();
  const id = useSubjectId();
  const type = useMemo(() => engine.getSubjectData(id).type, [engine, id]);
  const styles = useStyles([type]);

  return (
    <div
      aria-label="subject content container"
      className={styles.contentContainer}
    >
      {children}
    </div>
  );
};

export default ContentContainer;
